export default __webpack_public_path__ + "static/media/latest-news-logo-removebg-preview.e55247e0.png";